module.exports = __webpack_public_path__ + "static/fig-02-bdf9e4dea17d1922a8df07c2d5114f8c.png";